import { useState } from "react";
import { Link } from "react-router-dom";
import { SquaresFour, ChartBar } from "@phosphor-icons/react";import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "./ui/sheet";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "./ui/accordion";
import { COURSE_MEGA_MENUS } from "../lib/megaMenuConfig";

// Mobile-only left drawer that merges one or more mega-menu configs into a
// single accordion. Designed to accept multiple menus so future page-specific
// mega menus can be merged here by passing a combined `menus` array.
export function MegaMenuDrawer({ menus = COURSE_MEGA_MENUS }) {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          type="button"
          aria-label="Open menu"
          className="md:hidden w-8 h-8 flex items-center justify-center text-[#6043EF] border border-zinc-200 rounded-sm hover:bg-[#6043EF]/5 transition-colors"
          data-testid="mega-drawer-trigger"
        >
          <SquaresFour size={17} weight="bold" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[86vw] max-w-sm p-0 flex flex-col" data-testid="mega-drawer-content">
        <SheetHeader className="px-5 py-4 bg-[#EA580C] text-left space-y-0">
          <SheetTitle className="flex items-center gap-2 text-white">
            <span className="w-7 h-7 bg-white/15 flex items-center justify-center shrink-0">
              <ChartBar size={16} weight="bold" className="text-white" />
            </span>
            <span className="font-heading font-black text-base tracking-tight text-white">
              Explore <span className="text-white">NEET</span>COUNSEL
            </span>
          </SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-2 py-2">
          <Accordion type="single" collapsible defaultValue={menus[0]?.id}>
            {menus.map((m) => (
              <AccordionItem key={m.id} value={m.id} className="border-zinc-100">
                <AccordionTrigger
                  className="px-3 text-xs font-bold uppercase tracking-[0.12em] text-[#09090B] no-underline hover:no-underline"
                  data-testid={`mega-drawer-menu-${m.id}`}
                >
                  {m.label}
                </AccordionTrigger>
                <AccordionContent className="px-3">
                  <div className="flex flex-col gap-3">
                    {m.sections.map((s) => (
                      <div key={s.id}>
                        <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#6043EF] mb-1">
                          {s.label}
                        </p>
                        <div className="flex flex-col">
                          {s.links.map((l) => (
                            <Link
                              key={l.label}
                              to={l.to}
                              onClick={() => setOpen(false)}
                              className="py-1.5 text-sm text-[#52525B] hover:text-[#6043EF] transition-colors"
                              data-testid={`mega-drawer-link-${m.id}`}
                            >
                              {l.label}
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </SheetContent>
    </Sheet>
  );
}
